export default __webpack_public_path__ + "static/media/meta.4de04214.png";